// extracted by mini-css-extract-plugin
export default {"placeholderClass":"_fc198cc3"};